import publishers from '@/api/publishers'
import helpers, { sortDataByColumn } from '@/utils/helpers'

const state = {
  loading: false,
  error: null,
  api_reports: [],
}

const mutations = {
  SET_LOADING(state, loading) {
    state.loading = loading
  },
  SET_ERROR(state, error) {
    state.error = error
  },
  SET_API_REPORTS(state, data) {
    state.api_reports = data
  },
}

const actions = {
  handleSortApiReports({ state }, { column, order }) {
    sortDataByColumn(state.api_reports?.data?.data, column, order)
  },

  async fetchApiConversionReports({ commit }, payload) {
    commit('SET_LOADING', true)
    return await publishers
      .fetchApiConversionReports(payload)
      .then((response) => {
        commit('SET_API_REPORTS', response.data.data)
        commit('SET_LOADING', false)
        return response.data.data
      })
      .catch((error) => {
        commit('SET_ERROR', helpers.getError(error))
        commit('SET_LOADING', false)
      })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
